// extracted by mini-css-extract-plugin
export default {"SidebarItemsContainer":"SidebarItems_SidebarItemsContainer__qzJT0"};